import { Product } from '~/Api/Product';

import logGoogleTagManagerEvent from './logGoogleTagManagerEvent';

export default function logGoogleTagManagerGroupProductsRemove(groupId: string, products: Product[]) {
	logGoogleTagManagerEvent({
		event: 'cogvio.groupProductsRemove',
		groupProductsRemove: {
			group: {
				id: groupId,
			},
			products: products.map((product) => ({
				id: product.id,
				brandName: product.brandName,
			})),
		},
	});
}
